import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <Section background="white" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-2">
        {/* For You */}
        <div data-id="element-3">
          <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-4">
            <span className="bg-green-100 text-green-700 p-1 rounded" data-id="element-5">
              <CheckCircle2 className="w-5 h-5" data-id="element-6" />
            </span>
            Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-7">
            {['Eres mujer 40+', 'Despiertas entre 2–4am con frecuencia', 'Quieres algo práctico, sin misticismo y sin culpa', 'Quieres sentirte más tú en el día'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700" data-id="element-8">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-9" />
                <span data-id="element-10">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div data-id="element-11">
          <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-12">
            <span className="bg-red-100 text-red-700 p-1 rounded" data-id="element-13">
              <XCircle className="w-5 h-5" data-id="element-14" />
            </span>
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-15">
            {['Buscas una “cura milagro” sin hacer ajustes', 'Tienes señales de apnea severa o síntomas alarmantes y no quieres evaluarte (la guía te orienta, pero no sustituye atención médica)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700" data-id="element-16">
                <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-17" />
                <span data-id="element-18">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}